import React from 'react';
import { FiMapPin, FiPhone, FiMail, FiMessageCircle } from 'react-icons/fi';
import PageTransition from '../components/PageTransition';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  return (
    <PageTransition>
      <div className="bg-brand-cream py-16 text-center px-4">
        <span className="font-script text-3xl text-brand-sage mb-2 block">Reach Out</span>
        <h1 className="font-serif text-4xl md:text-5xl text-brand-dark">Contact Us</h1>
      </div>

      <div className="container mx-auto px-6 max-w-6xl pb-24">
        <div className="grid md:grid-cols-2 gap-16">
          {/* Contact Info & FAQ */}
          <div>
            <h2 className="font-serif text-3xl text-brand-dark mb-8">Get in Touch</h2>
            <p className="text-brand-sage font-light mb-10">
              Whether you're ready to book or just have a few questions about your stay in Lucban, we're here to help. Reach out to us through any of the channels below.
            </p>
            
            <div className="space-y-6 mb-12">
              <div className="flex items-start gap-4">
                <div className="bg-brand-olive text-brand-cream p-3 rounded-full shrink-0">
                  <SafeIcon icon={FiPhone} className="text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-brand-dark">Phone / Viber / WhatsApp</h4>
                  <p className="text-brand-sage">+63 917 681 8251</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-brand-olive text-brand-cream p-3 rounded-full shrink-0">
                  <SafeIcon icon={FiMail} className="text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-brand-dark">Email</h4>
                  <p className="text-brand-sage">inquiries@rvenueapartelle.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-brand-olive text-brand-cream p-3 rounded-full shrink-0">
                  <SafeIcon icon={FiMapPin} className="text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-brand-dark">Address</h4>
                  <p className="text-brand-sage">
                    3rd Floor R. Venue Bldg Quezon Ave, <br/>
                    cor Avenida Rizal, Lucban, 4328 Quezon
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-sm border border-brand-light/50">
              <h3 className="font-serif text-xl text-brand-dark mb-4">Quick FAQ</h3>
              <div className="space-y-4">
                <div>
                  <p className="font-medium text-brand-dark text-sm">Is parking available?</p>
                  <p className="text-brand-sage text-sm font-light">Street parking is available nearby. Please coordinate with us prior to arrival.</p>
                </div>
                <div>
                  <p className="font-medium text-brand-dark text-sm">How far is the town center?</p>
                  <p className="text-brand-sage text-sm font-light">We are located at the very heart of the town, just steps away from the Plaza and major landmarks.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-brand-light/30">
            <h3 className="font-serif text-2xl text-brand-dark mb-6">Send an Inquiry</h3>
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div>
                <label className="block text-sm text-brand-sage uppercase tracking-wider mb-2" htmlFor="name">Full Name</label>
                <input type="text" id="name" className="w-full border-b border-brand-light py-2 px-1 focus:outline-none focus:border-brand-olive transition-colors bg-transparent text-brand-dark" placeholder="Juan Dela Cruz" />
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm text-brand-sage uppercase tracking-wider mb-2" htmlFor="email">Email</label>
                  <input type="email" id="email" className="w-full border-b border-brand-light py-2 px-1 focus:outline-none focus:border-brand-olive transition-colors bg-transparent text-brand-dark" placeholder="juan@example.com" />
                </div>
                <div>
                  <label className="block text-sm text-brand-sage uppercase tracking-wider mb-2" htmlFor="phone">Phone Number</label>
                  <input type="tel" id="phone" className="w-full border-b border-brand-light py-2 px-1 focus:outline-none focus:border-brand-olive transition-colors bg-transparent text-brand-dark" placeholder="09..." />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm text-brand-sage uppercase tracking-wider mb-2" htmlFor="dates">Preferred Dates</label>
                  <input type="text" id="dates" className="w-full border-b border-brand-light py-2 px-1 focus:outline-none focus:border-brand-olive transition-colors bg-transparent text-brand-dark" placeholder="e.g. May 14-16" />
                </div>
                <div>
                  <label className="block text-sm text-brand-sage uppercase tracking-wider mb-2" htmlFor="guests">Number of Guests</label>
                  <select id="guests" className="w-full border-b border-brand-light py-2 px-1 focus:outline-none focus:border-brand-olive transition-colors bg-transparent text-brand-dark" >
                    <option>1-2 Guests</option>
                    <option>3 Guests</option>
                    <option>4 Guests</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm text-brand-sage uppercase tracking-wider mb-2" htmlFor="message">Message / Special Requests</label>
                <textarea id="message" rows="4" className="w-full border border-brand-light p-3 focus:outline-none focus:border-brand-olive transition-colors bg-transparent text-brand-dark rounded-sm resize-none" placeholder="How can we help you?" ></textarea>
              </div>
              <button type="submit" className="w-full bg-brand-olive text-brand-cream py-4 uppercase tracking-widest font-bold hover:bg-brand-dark transition-colors duration-300 rounded-sm mt-4" >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default Contact;